/**
 * Role Directive
 * Usage: v-role="'administrator'" or v-role="['curator', 'administrator']"
 */

import type { Directive, DirectiveBinding } from 'vue'
import { useAuthStore } from '@/stores/auth.store'
import type { UserRole } from '@/types/auth.types'

export const vRole: Directive = {
    mounted(el: HTMLElement, binding: DirectiveBinding<UserRole | UserRole[]>) {
        const authStore = useAuthStore()
        const requiredRoles = Array.isArray(binding.value) ? binding.value : [binding.value]

        const hasRole = authStore.userRoles.some((role: UserRole) => requiredRoles.includes(role))
        if (!hasRole) {
            el.style.display = 'none'
        }
    },
    updated(el: HTMLElement, binding: DirectiveBinding<UserRole | UserRole[]>) {
        const authStore = useAuthStore()
        const requiredRoles = Array.isArray(binding.value) ? binding.value : [binding.value]

        const hasRole = authStore.userRoles.some((role: UserRole) => requiredRoles.includes(role))
        if (!hasRole) {
            el.style.display = 'none'
        } else {
            el.style.display = ''
        }
    },
}

export default vRole
